import { isEmptyObject } from '../validators/formValidators';
import { replaceFieldsInConfig,
         isValidSubscriptionStatus } from '../helpers/utils';

import { setClientToken } from '../../client/token';
import _ from 'lodash';

const defaultState = {
    loggedIn: undefined,
    owner: undefined,
    employees: undefined,
    config: undefined,
    token: undefined,
    billing: undefined,
    downloadPath: undefined,
    tasks: undefined,
    stats: undefined,
};

const mergeOwnerDataToUser = (owner, user) => {
    let merged = {...owner, ...user};
    if (!user['GmailAccount']) {
        delete merged['GmailAccount'];
    }

    if (!user['OutlookAccount']) {
        delete merged['OutlookAccount'];
    }

    if (!user['welcomeTourDone']) {
        delete merged['welcomeTourDone'];
    }

    // The theme is personal: an employee without one must not inherit the owner's.
    if (!user['Theme']) {
        delete merged['Theme'];
    }

    return merged;
};

export const userReducer = (state = defaultState, action) => {
    let owner;
    let employees;
    let user;
    let config;
    let token;
    let loggedIn;
    let tasks;
    switch (action.type) {
        case 'LOG_IN_FORM_SUCCESS':
            token = action.result.data.token;            
            if (!isEmptyObject(token)) {
                owner = {...action.result.data.owner};
                user = mergeOwnerDataToUser(owner, action.result.data.user);
                if (isValidSubscriptionStatus(user)) {
                    setClientToken(token);
                }

                config = {...action.result.data.config};
                employees = [...action.result.data.employees];

            } else {
                token = undefined;
            }

            return {
                ...state,
                loggedIn: user,
                owner,
                employees,
                token,
                config,
            };

        case 'USER_LOG_IN_LOAD_SUCCESS':
            user = {...action.result.data.user};
            if (!isEmptyObject(user)) {
                config = {...action.result.data.config};
                owner = {...action.result.data.owner};
                employees = [...action.result.data.employees];
                user = mergeOwnerDataToUser(owner, user);

            } else {
                user = undefined;
            }

            return {
                ...state,
                loggedIn: user,
                owner,
                employees,
                config
            };

        case 'USER_LOG_IN_LOAD_FAILURE':
            return {
                ...state,
                loggedIn: undefined,
                config: undefined,
                owner: undefined,
                employees: undefined
            };

        case 'SIGN_UP_FORM_SUCCESS':
            token = action.result.data.token;
            loggedIn = {...action.result.data.user};
            if (isValidSubscriptionStatus(loggedIn)) {
                setClientToken(token);
            }

            return {
                ...state,
                loggedIn,
                owner: {...action.result.data.user},
                employees: undefined,
                token,
                config: {...action.result.data.config},
            };

        case 'ADD_EMPLOYEE_SUCCESS':
            employees = [];
            if (state.employees) {
                employees = [...state.employees];
            }

            employees.push(action.result.data.employee);
            return {
                ...state,
                employees
            };

        case 'DELETE_EMPLOYEE_SUCCESS':
            return {
                ...state,
                owner: {...action.result.data.owner},
                employees: [...action.result.data.employees],
                user: mergeOwnerDataToUser(action.result.data.owner, action.result.data.user),
            };

        case 'IMPERSONATE_EMPLOYEE_SUCCESS':
            token = action.result.data.token;
            loggedIn = mergeOwnerDataToUser(action.result.data.owner, action.result.data.user);
            if (isValidSubscriptionStatus(loggedIn)) {
                setClientToken(token);
            }

            return {
                ...state,
                loggedIn,
                owner: {...action.result.data.owner},
                employees: [...action.result.data.employees],
                token,
                config: {...action.result.data.config},
            };

            break;

        case 'UPDATE_MY_ACCOUNT_SUCCESS':
            token = action.result.data.token;
            loggedIn = mergeOwnerDataToUser(action.result.data.owner, action.result.data.user);
            if (isValidSubscriptionStatus(loggedIn)) {
                setClientToken(token);
            }

            return {
                ...state,
                loggedIn,
                owner: {...action.result.data.owner},
                token: action.result.data.token,
            };

        case 'RESET_PASSWORD_SUCCESS':
            token = action.result.data.token;
            if (isValidSubscriptionStatus(state.loggedIn)) {
                setClientToken(token);
            }

            return {
                ...state,
                token,
            }

        case 'USER_NOTIFICATIONS_SUCCESS':
        case 'USER_DISMISS_FAX_NOTIFICATION_SUCCESS':
            const failedFaxes = [...action.result.data.pollResults.rows];
            if (_.isEqual(failedFaxes, state.failedFaxes)) {
                return state;
            }

            return {
                ...state,
                failedFaxes,
            };

        case 'CONFIG_UPSERT_SUCCESS':
        case 'CONFIG_DELETE_SUCCESS':
        case 'CASES_COLUMNS_SET_SUCCESS':
        case 'CLIENTS_COLUMNS_SET_SUCCESS':
            return {
                ...state,
                config: {...action.result.data}
            };

        case 'FAX_STATUS_SUCCESS':
            let faxStatus = {...action.result.data.pollResults};
            return {
                ...state,
                billing: {...faxStatus['$billing$']}
            };

        case 'USER_DOWNLOAD_FILE':
            return {
                ...state,
                downloadPath: action.downloadPath
            };

        case 'PUBLIC_CASE_GET_SUCCESS':
            return {
                ...state,
                config: { 
                    workflow: [ ...action.result.data.workflow ],
                },
                loggedIn: { ...action.result.data.user },
            };

        case 'USER_BUY_FAX_CREDIT_SUCCESS':
            return {
                ...state,
                billing: {...action.result.data}
            };

        case 'USER_LAWPAY_ACCOUNT_SET_SUCCESS':
        case 'USER_PAYPAL_ACCOUNT_SET_SUCCESS':
            user = {...action.result.data};
            return {
                ...state,
                loggedIn: user,
                owner: user,
            };

        case 'USER_EMAIL_INTEGRATED':
            user = {...state.loggedIn};
            user['GmailAccount'] = action.integrated && action.tokenName === 'GmailToken';
            user['OutlookAccount'] = action.integrated && action.tokenName === 'OutlookToken';
            return {
                ...state,
                loggedIn: user
            };

        case 'USER_DRIVE_INTEGRATED':
            user = {...state.loggedIn};
            user['GDriveAccount'] = action.integrated && action.tokenName === 'GDriveToken';
            user['OneDriveAccount'] = action.integrated && action.tokenName === 'OneDriveToken';
            return {
                ...state,
                loggedIn: user
            };


        case 'USER_EMAIL_INTEGRATION_DELETE_SUCCESS':
            user = {...state.loggedIn};
            delete user['GmailAccount'];
            delete user['OutlookAccount'];
            return {
                ...state,
                loggedIn: user
            };

        case 'CASES_LOAD_SUCCESS':
            if (action.append) {
                return state;
            }

            return {
                ...state,
                tasks: [...action.result.data.tasks],
                stats: {...action.result.data.stats},
            };            
       
        case 'CLIENTS_LOAD_SUCCESS':
            if (action.append) {
                return state;
            }

            return {
                ...state,
                stats: { ...action.result.data.stats },
            };

        case 'CASE_EVENTS_LOAD_SUCCESS':
        case 'CASE_REFRESH_SUCCESS':
        case 'CASE_EDIT_ID_SUCCESS':
                const faxesPoll = action.result.data.events && action.result.data.events.faxesPoll;
                const billing = faxesPoll && faxesPoll.pollResults && faxesPoll.pollResults['$billing$'];
                const tasks = action.result.data.tasks ? [...action.result.data.tasks] : state.tasks;
                return {
                    ...state,
                    billing: { ...billing },
                    tasks,
                };

        case 'CLIENTS_LOAD_SUCCESS':
        case 'CLIENT_EDIT_ID_SUCCESS':
        case 'USER_TASK_UPDATE_SUCCESS':
        case 'CASE_DELETE_ID_SUCCESS':
        case 'INTAKE_FORM_SAVE_SUCCESS':
        case 'PARTIAL_MATTER_FORM_SAVE_SUCCESS':
            return {
                ...state,
                tasks: [...action.result.data.tasks]
            };

        case 'USER_TASKLISTS_UPDATE_SUCCESS':
        case 'USER_CASE_STATES_UPDATE_SUCCESS':
        case 'USER_FILTERS_UPDATE_SUCCESS':
        case 'USER_EMAIL_TEMPLATES_UPDATE_SUCCESS':
        case 'USER_SMS_TEMPLATES_UPDATE_SUCCESS':
        case 'USER_EMAIL_SIGNATURE_UPDATE_SUCCESS':
            return {
                ...state,
                config: { ...action.result.data },
            };

        case 'USER_LAWPAY_LIST_ACCOUNTS_FAILURE':
        case 'USER_LAWPAY_CANCEL_SUCCESS':
            user = {...state.loggedIn};
            delete user['LawPayAccessToken'];
            delete user['LawPayAccount'];
            return {
                ...state,
                loggedIn: user,
                owner: user,
            };

        case 'USER_PAYPAL_CANCEL_SUCCESS':
            user = {...state.loggedIn};
            delete user['PayPalAccount'];
            return {
                ...state,
                loggedIn: user,
                owner: user,
            };

        case 'USER_THEME_REQUEST':
            return {
                ...state,
                loggedIn: { ...state.loggedIn, Theme: action.args },
            };

        case 'USER_THEME_SUCCESS':
            return {
                ...state,
                loggedIn: { ...state.loggedIn, Theme: action.result.data.user.Theme },
            };

        case 'USER_TOUR_DONE_REQUEST':
            user = { ...state.loggedIn };
            user[action.args] = true;
            return {
                ...state,
                loggedIn: user,
            };

        case 'USER_TOUR_DONE_SUCCESS':
            user = { ...action.result.data.user };
            return {
                ...state,
                loggedIn: user,
                owner: { ...action.result.data.owner },
            };

        case 'USER_SMS_REGISTER_PHONE_SUCCESS':
            user = { ...state.loggedIn, 'PublicSmsPhone': action.result.data };
            return {
                ...state,
                loggedIn: user,
                owner: user
            };

        case 'USER_API_KEY_REGISTER_SUCCESS':
        case 'USER_DRIVE_CONFIG_SUCCESS':
            return {
                ...state,
                loggedIn: { ...action.result.data },
                owner: { ...action.result.data}
            };

        case 'USER_CALENDAR_DEFAULT_SUCCESS':
            user = { ...state.loggedIn, 'GmailCalendarId': action.result.data };
            return {
                ...state,
                loggedIn: user,
            };

        default:
            return state;
    }
};